import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import * as React from "react";

import { cn } from "../../handlers/cn.utils";
import { Icons } from "./icons";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef(
	({ className, sideOffset = 4, children, variant = "default", ...props }, ref) => (
		<TooltipPrimitive.Content
			ref={ref}
			sideOffset={sideOffset}
			className={cn(
				"z-[60] overflow-hidden rounded-md bg-gray-900 px-3 py-1.5 text-sm text-white shadow-md",
				"animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-1 data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1 data-[side=top]:slide-in-from-bottom-1",
				className,
			)}
			{...props}
		>
			{variant === "default" ? (
				<div className="flex items-center gap-1.5">
					<Icons.Tick className="h-3.5 w-3.5 text-white" />
					{children}
				</div>
			) : (
				children
			)}
		</TooltipPrimitive.Content>
	),
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
